"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelData = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
let TravelData = class TravelData {
    _id = (0, uuid_1.v4)();
    originId;
    destinationId;
    distance = 0;
    duration = 0;
    isManuallyModified = false;
};
exports.TravelData = TravelData;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TravelData.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TravelData.prototype, "originId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TravelData.prototype, "destinationId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
    // km
    ,
    __metadata("design:type", Number)
], TravelData.prototype, "distance", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
    // minutes
    ,
    __metadata("design:type", Number)
], TravelData.prototype, "duration", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], TravelData.prototype, "isManuallyModified", void 0);
exports.TravelData = TravelData = __decorate([
    (0, typeorm_1.Entity)("travelData")
], TravelData);
//# sourceMappingURL=TravelData.js.map